import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import { Protected } from "@/components/Protected";
import AuthPage from "@/pages/AuthPage";
import Dashboard from "@/pages/Dashboard";
import Students from "@/pages/Students";
import Expenses from "@/pages/Expenses";
import Withdrawals from "@/pages/Withdrawals";
import Ledger from "@/pages/Ledger";
import Accounts from "@/pages/Accounts";
import Settings from "@/pages/Settings";
import Contributions from "@/pages/Contributions";
import Gifts from "@/pages/Gifts";
import Advances from "@/pages/Advances";
import Feedback from "@/pages/Feedback";
import TaxForms from "@/pages/TaxForms";
import ImportExpenses from "@/pages/ImportExpenses";
import MyReceipts from "@/pages/MyReceipts";
import Approvals from "@/pages/Approvals";
import Scholarships from "@/pages/Scholarships";
import Projections from "@/pages/Projections";
import Help from "@/pages/Help";
import Resources from "@/pages/Resources";
import { AskAIProvider } from "@/context/AskAIContext";

function Shell() {
  const { user } = useAuth();
  return (
    <Routes>
      <Route path="/auth" element={user ? <Navigate to="/" replace /> : <AuthPage />} />
      <Route path="/" element={<Protected><Dashboard /></Protected>} />
      <Route path="/students" element={<Protected ownerOnly><Students /></Protected>} />
      <Route path="/expenses" element={<Protected><Expenses /></Protected>} />
      <Route path="/import" element={<Protected ownerOnly><ImportExpenses /></Protected>} />
      <Route path="/my-receipts" element={<Protected studentOnly><MyReceipts /></Protected>} />
      <Route path="/approvals" element={<Protected ownerOnly><Approvals /></Protected>} />
      <Route path="/receipts" element={<Navigate to="/import" replace />} />
      <Route path="/withdrawals" element={<Protected ownerOnly><Withdrawals /></Protected>} />
      <Route path="/ledger" element={<Protected><Ledger /></Protected>} />
      <Route path="/accounts" element={<Protected ownerOnly><Accounts /></Protected>} />
      <Route path="/contributions" element={<Protected ownerOnly><Contributions /></Protected>} />
      <Route path="/gifts" element={<Protected ownerOnly><Gifts /></Protected>} />
      <Route path="/advances" element={<Protected ownerOnly><Advances /></Protected>} />
      <Route path="/scholarships" element={<Protected ownerOnly><Scholarships /></Protected>} />
      <Route path="/projections" element={<Protected ownerOnly><Projections /></Protected>} />
      <Route path="/feedback" element={<Protected ownerOnly><Feedback /></Protected>} />
      <Route path="/tax-forms" element={<Protected ownerOnly><TaxForms /></Protected>} />
      <Route path="/settings" element={<Protected ownerOnly><Settings /></Protected>} />
      <Route path="/help" element={<Protected><Help /></Protected>} />
      <Route path="/resources" element={<Protected><Resources /></Protected>} />
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

export default function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <AskAIProvider>
          <Shell />
        </AskAIProvider>
        <Toaster position="top-right" richColors />
      </BrowserRouter>
    </AuthProvider>
  );
}
